import { ChangeEvent, FC } from "react";

interface Props {
    label: string;
    name: string;
    handleChange: (e: ChangeEvent<HTMLInputElement>, name: string) => void;
    value: string | number;
    required?: boolean;
    placeholder?: string;
    type:
        | "text"
        | "email"
        | "password"
        | "number"
        | "tel"
        | "url"
        | "search"
        | "date"
        | "time"
        | "datetime-local"
        | "month"
        | "week"
        | "color"
        | "file"
        | "hidden"
        | "checkbox"
        | "radio"
        | "range"
        | "submit"
        | "reset"
        | "button";
    max?: number;
    min?: number
}

const FormInput: FC<Props> = ({
    label,
    placeholder,
    name,
    handleChange,
    value,
    required = false,
    type,
    max,
    min = 1
}) => {
    return (
        <div className="w-100">
            <label htmlFor={name} className="form-label d-block mb-1">
                {label} {required && <span>*</span>}
            </label>
            <input
                type={type}
                name="complaint-type"
                id="complaintType"
                placeholder={placeholder}
                onChange={(e) => handleChange(e, name)}
                className="input-field w-100 mb-2"
                value={value}
                required={required}
                max={max || 1000000000000}
                min={min}
            />
        </div>
    );
};

export default FormInput;
